// import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
// import axios from "../api/axios";

// const PendingContext = createContext();

// export const PendingProvider = ({ children }) => {
//   const [pendingToDo, setPendingToDo] = useState(0);
//   const user_id = localStorage.getItem('user_id');

//   const fetchPendingItems = useCallback(async () => {
//     if (!user_id) return;
//     try {
//       const res = await axios.get('/pendingItem', {
//         params: { user_id }
//       });
//       setPendingToDo(res.data.pending_to_do || 0);
//     } catch (error) {
//       console.error("Fetch pending items failed:", error);
//     }
//   }, [user_id]);

//   // 初次登入或頁面整理時自動抓取
//   useEffect(() => {
//     console.log("fetchPendingItems")
//     fetchPendingItems();
//   }, [fetchPendingItems]);

//   return (
//     <PendingContext.Provider value={{ pendingToDo, refreshPending: fetchPendingItems }}>
//       {children}
//     </PendingContext.Provider>
//   );
// };

// export const usePending = () => useContext(PendingContext);

import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from "../api/axios";

const PendingContext = createContext();

export const PendingProvider = ({ children }) => {
  const [pendingToDo, setPendingToDo] = useState(0);

  // 1. 將 fetchPendingItems 改為動態從 localStorage 讀取最新的 user_id
  const fetchPendingItems = useCallback(async () => {
    const currentUserId = localStorage.getItem('user_id'); // 每次執行時才抓最新的
    
    if (!currentUserId) {
      setPendingToDo(0); // 沒 ID 就清空數字
      return;
    }

    try {
      const res = await axios.get('/pendingItem', {
        params: { user_id: currentUserId }
      });
      setPendingToDo(res.data.pending_to_do || 0);
    } catch (error) {
      console.error("Fetch pending items failed:", error);
    }
  }, []); // 移除 dependency，讓它保持穩定

  // 2. 監控全域變動（例如登入後的行為）
  useEffect(() => {
    fetchPendingItems();
  }, [fetchPendingItems]);

  return (
    <PendingContext.Provider value={{ pendingToDo, refreshPending: fetchPendingItems }}>
      {children}
    </PendingContext.Provider>
  );
};

export const usePending = () => useContext(PendingContext);